
import { defineComponent, onMounted } from 'vue';
import { AppTable, AppCard, AppButton } from '@/components';
import { useChatSentenceList } from '@/modules/chat/sentence/model/list';
import { ROUTE_NAME_CHAT } from '@/modules/chat/router';
import { TableColumnType, TableConfig } from '@/components/table/types';

export default defineComponent({
    name: ROUTE_NAME_CHAT.SENTENCE.INDEX,
    components: { AppTable, AppCard, AppButton },
    setup() {
        const { list, total, fetchList, remove } = useChatSentenceList();

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Text, label: 'ID', key: 'id' },
                { type: TableColumnType.Text, label: 'Name', key: 'name' },
                { type: TableColumnType.Text, label: 'Position', key: 'position' },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-language',
                        theme: 'info',
                        tooltip: 'Translate',
                        to: { name: ROUTE_NAME_CHAT.SENTENCE.TRANSLATE, params: { id: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-edit',
                        theme: 'info',
                        tooltip: 'Edit',
                        to: { name: ROUTE_NAME_CHAT.SENTENCE.EDIT, params: { id: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-trash-alt',
                        theme: 'danger',
                        tooltip: 'Delete',
                        disabled: !row.canDelete,
                        onClick: () => remove(row.id)
                    })
                }
            ]
        };

        onMounted(fetchList);

        return { table, list, total, fetchList, ROUTE_NAME_CHAT };
    }
});
